import type { NewTicketFormValuesT } from '../declarations';

export function creationAttachmentListLength(list: unknown): number {
  if (list && typeof list === 'object' && 'length' in list) {
    const n = Number((list as { length: number }).length);
    return Number.isFinite(n) && n > 0 ? n : 0;
  }
  return 0;
}

export function hasCreationAttachmentFiles(
  data: Pick<NewTicketFormValuesT, 'creationAttachmentFile' | 'creationAttachmentPhoto'>
): boolean {
  return (
    creationAttachmentListLength(data.creationAttachmentFile) > 0 ||
    creationAttachmentListLength(data.creationAttachmentPhoto) > 0
  );
}

/** Zod-parsed submit data can omit FileList fields; read live values from react-hook-form. */
export function withLiveCreationAttachmentFields(
  data: NewTicketFormValuesT,
  getValues: () => NewTicketFormValuesT
): NewTicketFormValuesT {
  const live = getValues();
  return {
    ...data,
    creationAttachmentNote: live.creationAttachmentNote ?? data.creationAttachmentNote,
    creationAttachmentTypeCode: live.creationAttachmentTypeCode ?? data.creationAttachmentTypeCode,
    creationAttachmentFile: live.creationAttachmentFile ?? data.creationAttachmentFile,
    creationAttachmentPhoto: live.creationAttachmentPhoto ?? data.creationAttachmentPhoto,
  };
}
